import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const QuantityWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 1px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-color: ${props => props.color || '#42b4e6'};
  background-color: white;
  box-sizing: border-box;
`;

const QuantityLabel = styled.span`
  width: 40px;
  height: 20px;
  border: none;
  text-align: center;
`;

const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 17.5px;
  width: 17.5px;
  box-sizing: border-box;
  color: ${props => props.textColor || 'white'};
  background-color: ${props => props.color || '#42b4e6'};
  cursor: pointer;
  user-select: none;
  padding: 2px;

  ${(props) => (props.disabled ? `opacity:0.5;pointer-events:none;` : "")}
`;

const IncreaseButton = styled(Button)`
  border-top-right-radius: 3px;
  margin-bottom: 1px;

  svg {
    transform: rotate(180deg);
  }
`;

const DecreaseButton = styled(Button)`
  border-bottom-right-radius: 3px;
`;

const ButtonsML = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

class QuantityEditor extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    primaryColor: PropTypes.string,
    primaryTextColor: PropTypes.string,
    quantity: PropTypes.number.isRequired,
    canIncrease: PropTypes.bool,
    onIncrease: PropTypes.func,
    canDecrease: PropTypes.bool,
    onDecrease: PropTypes.func,
    isSaving: PropTypes.bool,
  };

  render() {
    const decreaseDisabled = this.props.isSaving || !this.props.canDecrease;
    const increaseDisabled = this.props.isSaving || !this.props.canIncrease;

    const increaseIdProps = {};
    const decreaseIdProps = {};

    if (this.props.id) {
      increaseIdProps['id'] = `${this.props.id}-quantity-editor-increase`;
      decreaseIdProps['id'] = `${this.props.id}-quantity-editor-decrease`;
    }

    return (
      <QuantityWrapper color={this.props.primaryColor}>
        <QuantityLabel>{this.props.quantity}</QuantityLabel>
        <ButtonsML>
          <IncreaseButton
            {...increaseIdProps}
            color={this.props.primaryColor}
            textColor={this.props.primaryTextColor}
            disabled={increaseDisabled}
            onClick={() => {
              if (!increaseDisabled) {
                this.props.onIncrease();
              }
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
              <g>
                <polygon  fill="currentColor" points="512,712.9 704,520.9 896,328.9 512,328.9 128,328.9 320,520.9  " />
              </g>
            </svg>
          </IncreaseButton>
          <DecreaseButton
            {...decreaseIdProps}
            color={this.props.primaryColor}
            textColor={this.props.primaryTextColor}
            disabled={decreaseDisabled}
            onClick={() => {
              if (!decreaseDisabled) {
                this.props.onDecrease();
              }
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
              <g>
                <polygon fill="currentColor" points="512,712.9 704,520.9 896,328.9 512,328.9 128,328.9 320,520.9  " />
              </g>
            </svg>
          </DecreaseButton>
        </ButtonsML>
      </QuantityWrapper>
    );
  }
}

export default QuantityEditor;
